import styled from 'styled-components';

interface RowContainerProps {
  height?: string;
  width?: string;
  maxWidth?: string;
  gap?: string;
  margin?: string;
  flexDirection?: string;
  alignItem?: string;
  justifyContent?: string;
  flex?: string;
  padding?: string;
  position?: string;
  bgColor?: string;
  color?: string;
  flexWrap?: string;
  left?: string;
  margintop?: string;
  marginleft?: string;
  top?: string;
  borderBottom?: string;
  borderRadius?: string;
  textalign?: string;
  cursor?: string;
  borderTop?: string;
  border?: string;
  display?: string;
  isActive?: boolean;
  background?: string;
  bottom?: string;
}

// List of custom props that should NOT be forwarded to the DOM element
const CUSTOM_PROPS = new Set([
  'height', 'width', 'maxWidth', 'gap', 'margin', 'flexDirection', 'alignItem',
  'justifyContent', 'flex', 'padding', 'position', 'bgColor', 'color', 'flexWrap',
  'left', 'margintop', 'marginleft', 'top', 'borderBottom', 'borderRadius',
  'textalign', 'cursor', 'borderTop', 'border', 'display', 'isActive',
  'background', 'bottom',
]);

const RowContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !CUSTOM_PROPS.has(prop),
}) <RowContainerProps>`
  height: ${(props) => props.height ?? ""};
  width: ${(props) => props.width ?? "100%"};
  top: ${(props) => props.top ?? ""};
  max-width: ${(props) => props.maxWidth ?? ""};
  left: ${(props) => props.left ?? " "};
  flex-wrap: ${(props) => props.flexWrap ?? ""};
  display: ${(props) => props.display ?? "flex"};
  flex: ${(props) => props.flex ?? ""};
  flex-direction: ${(props) => props.flexDirection ?? "row"};
  align-items: ${(props) => props.alignItem ?? "start"};
  justify-content: ${(props) => props.justifyContent ?? "flex-start"};
  gap: ${(props) => props.gap ?? "10px"};
  margin: ${(props) => props.margin || ""};
  margin-left: ${(props) => props.marginleft || ""};
  margin-top: ${(props) => props.margintop || ""};
  padding: ${(props) => props.padding ?? ""};
  position: ${(props) => props.position ?? ""};
  background-color: ${(props) => props.bgColor || ""};
  color: ${(props) => props.color || ""};
  background: ${(props) => props.background || ""};
  border-bottom: ${(props) => props.borderBottom || ""};
  border-top: ${(props) => props.borderTop || ""};
  border-radius: ${(props) => props.borderRadius || ""};
  border: ${(props) => props.border || ""};
  bottom: ${(props) => props.bottom || ""};
  text-align: ${(props) => props.textalign ?? ""};
  cursor: ${(props) => props.cursor ?? ""};
`;

export default RowContainer;
